import React from 'react'
import PropTypes from 'prop-types'
import {
  CarePlanSectionContent,
  CarePlanSectionHeader,
} from '../../../../../components/carePlans'

export default function InitialAssessmentPreview({ initialAssessment }) {
  return (
    <div>
      <Section title="Strengths" content={initialAssessment.strengths || ''} />
      <Section title="Needs" content={initialAssessment.needs || ''} />
    </div>
  )
}

const Section = ({ title, content }) => (
  <div style={styles.sectionContainer}>
    <CarePlanSectionHeader title={title} />
    <CarePlanSectionContent value={content} />
  </div>
)

const styles = {
  sectionContainer: {
    paddingTop: 55,
  },
}

InitialAssessmentPreview.propTypes = {
  initialAssessment: PropTypes.object.isRequired,
}
